import Company from "./containers"

export default Company
